import {
  VisitasAgendaFila,
  VisitasAgendaNamed,
} from '../types/visitasAgenda';
import visitasAgendaService, {
  DEFAULT_AGENDA_ID,
  DEFAULT_AGENDA_NOMBRE,
} from './visitasAgendaService';

export { DEFAULT_AGENDA_ID, DEFAULT_AGENDA_NOMBRE };

const virtualAgenda = (filas: VisitasAgendaFila[] = []): VisitasAgendaNamed => ({
  id: DEFAULT_AGENDA_ID,
  nombre: DEFAULT_AGENDA_NOMBRE,
  filas,
  updatedAt: new Date().toISOString(),
});

export const listVisitasAgendas = (): VisitasAgendaNamed[] => [virtualAgenda()];

export const getActiveAgendaId = (): string => DEFAULT_AGENDA_ID;

export const setActiveAgendaId = (_id: string): void => {
  /* maestro único en API */
};

export const loadVisitasAgendaFilas = async (): Promise<VisitasAgendaFila[]> =>
  visitasAgendaService.fetchAllFilas();

export const getVisitasAgendaById = (id: string): VisitasAgendaNamed | null => {
  if (id !== DEFAULT_AGENDA_ID) return null;
  return virtualAgenda();
};

export const getActiveVisitasAgenda = (): VisitasAgendaNamed => virtualAgenda();

export const saveVisitasAgendaFilas = async (
  _agendaId: string,
  filas: VisitasAgendaFila[],
): Promise<VisitasAgendaNamed | null> => {
  const saved = await visitasAgendaService.reemplazar(filas);
  return virtualAgenda(saved);
};
